import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
} from "../../../../components/Models/admin-modal-theme";
import { brandPalette } from "../../../../constants/brandPalette";
import { registerMarkSchemeRequest } from "../../../../modules/admin-modules/mark-schemes/Actions";
import {
  GraderModelFields,
  useGraderModelSelection,
} from "../../correct-student-exams/grading-model-field";

const RegisterMarkSchemeModal = ({ scheme, fileUrl, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.markSchemes.isLoading);
  const { groups, model, onModelChange, isLoadingModels } = useGraderModelSelection(isOpen);

  const handleRegister = () => {
    if (!scheme?.title || !fileUrl || isLoading) return;
    dispatch(
      registerMarkSchemeRequest(
        {
          title: scheme.title,
          url: fileUrl,
          ocr_model: model,
          grading_model: model,
        },
        onClose
      )
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={isLoading ? () => {} : onClose} size="lg">
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
      <ModalContent
        {...adminModalContentProps}
        bg="var(--surface-raised)"
        color="var(--text-primary)"
      >
        <ModalHeader {...adminModalHeaderProps}>Register mark scheme</ModalHeader>
        {!isLoading ? <ModalCloseButton color="var(--text-primary)" /> : null}
        <ModalBody {...adminModalBodyProps}>
          <Text fontSize="sm" color="var(--text-muted)" mb={4}>
            {scheme?.title || scheme?.name || "Mark scheme"}
          </Text>
          <GraderModelFields
            groups={groups}
            model={model}
            onModelChange={onModelChange}
            isDisabled={isLoading}
            isLoading={isLoadingModels}
          />
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="ghost" onClick={onClose} fontWeight="700" isDisabled={isLoading}>
            Cancel
          </Button>
          <Button
            bg={brandPalette.primary}
            color="white"
            fontWeight="700"
            onClick={handleRegister}
            isLoading={isLoading}
            loadingText="Registering…"
            isDisabled={isLoading || isLoadingModels || !fileUrl}
            _hover={{ bg: brandPalette.secondary }}
          >
            Register
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RegisterMarkSchemeModal;
